import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';

export type CodeBlockItem = {
  language: string;
  content: string;
};

// Renders a fenced code block with a registered language (e.g. ```recordings)
// as a rich component instead of a <pre> block. Return null from render to
// fall back to the default code block rendering.
export type CodeBlockExtensionOptions =
  ItemRenderExtensionOptions<CodeBlockItem>;

export const CodeBlockExtensions =
  createItemRenderExtensions<CodeBlockExtensionOptions>({
    id: 'code-block',
  });

export const createCodeBlockExtension = (options: CodeBlockExtensionOptions) =>
  createItemRenderExtension<CodeBlockExtensionOptions>(options);

export const useCodeBlockExtensions = () =>
  useItemRenderExtensions<CodeBlockExtensionOptions>(CodeBlockExtensions);
